import { useParams } from 'react-router-dom';
import { useModal } from 'src/hooks/modalHooks';
import { DataTableActions } from 'src/components/DataTable';
import { SolutionSignatureWhitelistItem } from '../../types';
import SignatureWhitelistEditModal from './SignatureWhitelistEditModal';
import SignatureWhitelistDeleteModal from './SignatureWhitelistDeleteModal';
import { useSolutionUserRoles } from '../../hooks';

type Props = {
  item?: SolutionSignatureWhitelistItem;
};

function SignatureWhitelistAction({ item }: Props) {
  const { solutionId } = useParams();
  const { isValidSolutionOwner } = useSolutionUserRoles(solutionId);
  const [DeleteDialog, handleDelete] = useModal(SignatureWhitelistDeleteModal, {
    item,
  });
  const [EditDialog, handleEdit] = useModal(SignatureWhitelistEditModal, {
    item,
    title: 'Edit OS signature',
  });

  return (
    <DataTableActions
      canEdit={isValidSolutionOwner}
      canDelete={isValidSolutionOwner}
      onEdit={handleEdit}
      onDelete={handleDelete}
    >
      {EditDialog}
      {DeleteDialog}
    </DataTableActions>
  );
}

export default SignatureWhitelistAction;
